(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4283],{

/***/ 69987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97729);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37555);







var Meta = function(_param) {
    var dismissSeoTags = _param.dismissSeoTags, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "dismissSeoTags"
    ]);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var defaultTitle = "YEMA: As\xed de f\xe1cil, as\xed de bueno";
    var title = props.title ? "".concat(props.title, " | YEMA") : defaultTitle;
    var pageUrl = ("https://yema.mx" + router.asPath).split(/[?#]/)[0];
    var canonical = props.canonicalUrl ? props.canonicalUrl : pageUrl;
    var shouldIndex = props.shouldIndex;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            shouldIndex && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "index, follow",
                name: "robots"
            }),
            shouldIndex && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "index/ follow",
                name: "googlebot"
            }),
            !dismissSeoTags && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "name",
                        itemProp: "name",
                        content: title
                    }, "name"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        itemProp: "description",
                        content: props.description
                    }, "description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "image",
                        itemProp: "image",
                        content: props.image
                    }, "image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: props.keywords
                    }, "keywords"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: pageUrl
                    }, "og:url"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }, "og:type"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: title
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: props.description
                    }, "og:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: defaultTitle
                    }, "og:site_name"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: props.image
                    }, "og:image"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags",
                        "brand"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:brand",
                        content: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                            "productTags",
                            "brand"
                        ])
                    }, "product:brand"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags",
                        "hasStock"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:availability",
                        content: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                            "productTags",
                            "hasStock"
                        ]) ? "in stock" : "out of stock"
                    }, "product:availability"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:condition",
                        content: "new"
                    }, "product:condition"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags",
                        "price"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:price:amount",
                        content: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                            "productTags",
                            "price"
                        ])
                    }, "product:price:amount"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags",
                        "currency"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:price:currency",
                        content: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                            "productTags",
                            "currency"
                        ])
                    }, "product:price:currency"),
                    (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                        "productTags",
                        "id"
                    ]) !== null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "product:retailer_item_id",
                        content: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(props, [
                            "productTags",
                            "id"
                        ])
                    }, "product:retailer_item_id"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "fb:app_id",
                        content: "2504608542988597"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }, "twitter:card"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: title
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: props.description
                    }, "twitter:description"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@yemamx"
                    }, "twitter:site"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@yemamx"
                    }, "twitter:creator"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: props.image
                    }, "twitter:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: canonical
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "alternate",
                        href: pageUrl,
                        hrefLang: "x-default"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "alternate",
                        href: pageUrl,
                        hrefLang: "es-MX"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "google",
                content: "notranslate"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/ico",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                href: "/favicon.png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preconnect",
                href: "https://cdn.ravenjs.com",
                crossOrigin: "true"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "preconnect",
                href: "https://us-central1-yema-cdn-dev.cloudfunctions.net"
            })
        ]
    });
};
Meta.defaultProps = {
    title: null,
    description: "YEMA: el primer s\xfaper consciente de M\xe9xico. As\xed de bueno. As\xed de f\xe1cil.",
    keywords: "productos saludables, productos org\xe1nicos, comida saludable, tienda de productos org\xe1nicos, productos naturales, productos ecol\xf3gicos, tienda de productos saludables en M\xe9xico",
    image: "",
    canonicalUrl: null,
    shouldIndex: true,
    dismissSeoTags: false
};
Meta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    keywords: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    canonicalUrl: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    shouldIndex: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    dismissSeoTags: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool
};
/* harmony default export */ __webpack_exports__["Z"] = (Meta);


/***/ }),

/***/ 72754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(50930);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51992);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37555);
/* harmony import */ var _yema_commerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25144);
/* harmony import */ var functions_fnRequestAPIs_fnProductsAPI__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66221);
/* harmony import */ var functions_fnRequestAPIs_fnProductsPromotion__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18009);
/* harmony import */ var _yema_designkit_webkit_layouts_Section__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46350);
/* harmony import */ var _yema_designkit_webkit_molecules_NotFound__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(32012);















/** Import CMS Components */ var CMS_BannerSlider = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 3650).then(__webpack_require__.bind(__webpack_require__, 43650));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43650)
            ];
        }
    }
});
var CMS_Author = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 6529).then(__webpack_require__.bind(__webpack_require__, 96529));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96529)
            ];
        }
    }
});
var CMS_Banner = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 7221).then(__webpack_require__.bind(__webpack_require__, 77221));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77221)
            ];
        }
    }
});
var CMS_BannerSmall = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 9443).then(__webpack_require__.bind(__webpack_require__, 89443));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(89443)
            ];
        }
    }
});
var CMS_CardForm = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7529), __webpack_require__.e(7607)]).then(__webpack_require__.bind(__webpack_require__, 57270));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57270)
            ];
        }
    }
});
var CMS_Reviews = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 2947).then(__webpack_require__.bind(__webpack_require__, 72947));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(72947)
            ];
        }
    }
});
var CMS_RowCardGroup = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 9101).then(__webpack_require__.bind(__webpack_require__, 79101));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79101)
            ];
        }
    }
});
var CMS_Body = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 9256).then(__webpack_require__.bind(__webpack_require__, 9256));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9256)
            ];
        }
    }
});
var CMS_BodyTitle = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 1937).then(__webpack_require__.bind(__webpack_require__, 71937));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71937)
            ];
        }
    }
});
var CMS_ContactUsCard = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 8009).then(__webpack_require__.bind(__webpack_require__, 4413));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4413)
            ];
        }
    }
});
var CMS_Questions = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return __webpack_require__.e(/* import() */ 2598).then(__webpack_require__.bind(__webpack_require__, 42598));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42598)
            ];
        }
    }
});
var CMSAlgoliaProducts = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(1673), __webpack_require__.e(7261), __webpack_require__.e(4348)]).then(__webpack_require__.bind(__webpack_require__, 95616));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95616)
            ];
        }
    }
});
/**
 * These objects' keys are required to match wagtail component's type
 * DO NOT MODIFY these keys, unless they are modified in Wagtail first
 */ var components = {
    slider: CMS_BannerSlider,
    banner: CMS_Banner,
    reviews: CMS_Reviews,
    cardGroups: CMS_RowCardGroup,
    body: CMS_Body,
    body_content: CMS_Body,
    body_title: CMS_BodyTitle,
    body_title_block: CMS_BodyTitle,
    body_contact_us_card: CMS_ContactUsCard,
    body_questions: CMS_Questions,
    body_card_group: CMS_RowCardGroup,
    body_banner_slider: CMS_BannerSlider,
    body_home_slider: CMS_BannerSlider,
    body_banner: CMS_Banner,
    body_banner_small: CMS_BannerSmall,
    body_form: CMS_CardForm,
    body_written_by: CMS_Author,
    body_algolia_card_group: CMSAlgoliaProducts
};
var CMSPageSkeleton = function() {
    var duration = 1.2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                duration: duration,
                height: 280
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_yema_designkit_webkit_layouts_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: "pb-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "container mb-12",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "row",
                        children: [
                            1,
                            2,
                            3,
                            4,
                            5,
                            6
                        ].map(function(i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: "col-span-4 mb-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                        duration: duration,
                                        height: 80
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: "mt-1 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                                duration: duration,
                                                width: "90%"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "mb-4"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                                                duration: duration,
                                                width: "50%"
                                            })
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    })
                })
            })
        ]
    });
};
var CMS_PageBody = function(param) {
    var content = param.content;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_yema_commerce__WEBPACK_IMPORTED_MODULE_5__/* .useStateEngine */ .kG)(), 1), catalog = ref[0].catalog;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)((0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(content, [
        "body"
    ])), contentParsed = ref1[0], setContentParsed = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), renderedTime = ref2[0], setRenderedTime = ref2[1];
    var refetchAvailabilitiesAndPromotions = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _shouldRefetchAvailabilities, shouldRefetchAvailabilities, _shouldRefetchPromotions, shouldRefetchPromotions, ref, ref1, fetchedPromotionsPromise, fetchedAvailabilitiesPromise;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _shouldRefetchAvailabilities = param.shouldRefetchAvailabilities, shouldRefetchAvailabilities = _shouldRefetchAvailabilities === void 0 ? false : _shouldRefetchAvailabilities, _shouldRefetchPromotions = param.shouldRefetchPromotions, shouldRefetchPromotions = _shouldRefetchPromotions === void 0 ? false : _shouldRefetchPromotions;
                        ;
                        fetchedPromotionsPromise = shouldRefetchPromotions ? (0,functions_fnRequestAPIs_fnProductsPromotion__WEBPACK_IMPORTED_MODULE_7__/* .fetchProductsPromotions */ .a)({
                            gtinsToFetch: content.productsGtinsInPage,
                            plmIds: content.plmIdsInPage,
                            bundlesIdToFetch: content.bundlesIdsInPage,
                            storeId: catalog === null || catalog === void 0 ? void 0 : (ref = catalog.store) === null || ref === void 0 ? void 0 : ref.id
                        }) : null;
                        fetchedAvailabilitiesPromise = shouldRefetchAvailabilities ? (0,functions_fnRequestAPIs_fnProductsAPI__WEBPACK_IMPORTED_MODULE_6__/* .getProductsAvailability */ .hj)({
                            gtins: content.gtinsInPage,
                            plmIds: content.plmIdsInPage,
                            zipCode: catalog ? catalog.zipCode : null,
                            storeId: catalog === null || catalog === void 0 ? void 0 : (ref1 = catalog.store) === null || ref1 === void 0 ? void 0 : ref1.id
                        }) : null;
                        Promise.all([
                            fetchedPromotionsPromise,
                            fetchedAvailabilitiesPromise
                        ]).then(function(res) {
                            var fetchedPromotions = (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(res, [
                                0
                            ]);
                            var fetchedAvailabilities = (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(res, [
                                1
                            ]);
                            if (fetchedAvailabilities || fetchedPromotions.productsPromotions || fetchedPromotions.bundlesPromotions) {
                                var data = shouldRefetchAvailabilities && shouldRefetchPromotions ? (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(content, [
                                    "body"
                                ])) : (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(contentParsed);
                                data.filter(function(item) {
                                    return item.type === "card_group";
                                }).map(function(group) {
                                    var ref, ref1;
                                    (ref1 = (ref = (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(group, [
                                        "value",
                                        "cards"
                                    ], [])) === null || ref === void 0 ? void 0 : ref.filter(function(card) {
                                        return card.layout === "product";
                                    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(card) {
                                        var gtin = card.title;
                                        // Insert availability information
                                        if (card.product && shouldRefetchAvailabilities && fetchedAvailabilities) {
                                            var ref, ref1;
                                            var availability = fetchedAvailabilities === null || fetchedAvailabilities === void 0 ? void 0 : (ref = fetchedAvailabilities.availabilities) === null || ref === void 0 ? void 0 : ref.find(function(p) {
                                                return p.gtin === gtin;
                                            });
                                            if (availability) {
                                                card.product.availability = sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .dataTransformers.parseAvailability */ .IZ.parseAvailability(catalog === null || catalog === void 0 ? void 0 : catalog.zipCode, card.product, availability);
                                            } else {
                                                card.product.availability = {
                                                    checkoutMaxQuantity: 0,
                                                    availableOnZipCode: false,
                                                    itemsAvailable: 0,
                                                    status: "unavailable"
                                                };
                                            }
                                            card.product.catalogPrice = fetchedAvailabilities === null || fetchedAvailabilities === void 0 ? void 0 : (ref1 = fetchedAvailabilities.prices) === null || ref1 === void 0 ? void 0 : ref1.find(function(x) {
                                                return x.sku === gtin;
                                            });
                                        }
                                        // Insert promotion information
                                        if (card.product && shouldRefetchPromotions) {
                                            var promotion = card.isBundle ? fetchedPromotions.bundlesPromotions.find(function(p) {
                                                return p.sku === gtin;
                                            }) : fetchedPromotions.productsPromotions.find(function(p) {
                                                return p.gtin === gtin;
                                            });
                                            if (promotion) {
                                                var firstApplicableRule = sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .rules.getFirstApplicableRule */ .jQ.getFirstApplicableRule((0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(promotion, [
                                                    "applicableRules"
                                                ], []), gtin);
                                                card.product.firstApplicableRule = {
                                                    title: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(firstApplicableRule, [
                                                        "title"
                                                    ]),
                                                    icon: (0,sf_modules__WEBPACK_IMPORTED_MODULE_4__/* .get_ */ .jR)(firstApplicableRule, [
                                                        "campaignIcon"
                                                    ])
                                                };
                                            }
                                        }
                                    });
                                });
                                setContentParsed(data);
                                setRenderedTime(new Date().getTime().toString(36));
                            }
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function refetchAvailabilitiesAndPromotions(_) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (catalog && catalog.createdAt && catalog.createdAt !== "") {
            refetchAvailabilitiesAndPromotions({
                shouldRefetchAvailabilities: true,
                shouldRefetchPromotions: true
            });
        }
    // This useEffect should be triggered only on content change (i.e. client-side navigation)
    }, [
        content && content.slug
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (catalog && catalog.createdAt && catalog.createdAt !== "") {
            refetchAvailabilitiesAndPromotions({
                shouldRefetchAvailabilities: true,
                shouldRefetchPromotions: true
            });
        }
    // This useEffect should be triggered only on catalog settings change
    }, [
        catalog && catalog.createdAt
    ]);
    if (!contentParsed || !contentParsed.length) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CMSPageSkeleton, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: contentParsed && contentParsed.length ? "mb-12" : "",
        children: contentParsed.map(function(element, index) {
            if (!element.type) return "";
            var CustomComponent = components["body_".concat(element.type)];
            if (!CustomComponent) return "";
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomComponent, {
                blockId: index,
                slug: content.slug,
                typeName: content.__typename,
                content: element.value,
                isBlog: element.type === "banner" || element.type === "body_banner"
            }, "body-elt-".concat(index, "-").concat(renderedTime));
        })
    });
};
var CMS_Page = function(param) {
    var loading = param.loading, content = param.content;
    if (loading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CMSPageSkeleton, {});
    if (!loading && (!content || !content.body)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_yema_designkit_webkit_molecules_NotFound__WEBPACK_IMPORTED_MODULE_9__["default"], {});
    if (!content || Array.isArray(content.body) && !content.body.length) return "";
    if (typeof content.body === "string") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "mb-12",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CMS_Body, {
            content: content.body
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CMS_PageBody, {
        content: content
    });
};
CMS_Page.defaultProps = {};
CMS_Page.propTypes = {
    loading: prop_types__WEBPACK_IMPORTED_MODULE_14__.bool,
    content: prop_types__WEBPACK_IMPORTED_MODULE_14__.object
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_2__.memo(CMS_Page));


/***/ }),

/***/ 9327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25237);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37555);
/* harmony import */ var _yema_designkit_webkit_organisms_HeaderBlog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5539);
/* harmony import */ var components_Meta__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69987);
/* harmony import */ var constants_paths__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69514);











var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7529), __webpack_require__.e(9695), __webpack_require__.e(9057)]).then(__webpack_require__.bind(__webpack_require__, 60237));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60237)
            ];
        }
    },
    ssr: false
});
var Maintenance = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9598).then(__webpack_require__.bind(__webpack_require__, 42932));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(42932)
            ];
        }
    },
    ssr: false
});
var BlogLayout = function(_param) {
    var className = _param.className, staticContent = _param.staticContent, children = _param.children, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "className",
        "staticContent",
        "children"
    ]);
    if (staticContent && staticContent.withError) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Maintenance, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                className: className
            }, otherProps), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Meta__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, staticContent.metaTags)),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yema_designkit_webkit_organisms_HeaderBlog__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                blogUrl: "/blog",
                                storeUrl: "https://yema.mx"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                                children: children
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Footer, {
                                className: "",
                                type: "full",
                                navigation: (0,sf_modules__WEBPACK_IMPORTED_MODULE_3__/* .get_ */ .jR)(staticContent, [
                                    "pageNavigations",
                                    "footerMenu"
                                ], []),
                                facebookUrl: constants_paths__WEBPACK_IMPORTED_MODULE_9__/* .YEMA_FACEBOOK */ .hL,
                                instagramUrl: constants_paths__WEBPACK_IMPORTED_MODULE_9__/* .YEMA_INSTAGRAM */ .Yk,
                                twitterUrl: constants_paths__WEBPACK_IMPORTED_MODULE_9__/* .YEMA_TWITTER */ .qq,
                                whatsappUrl: constants_paths__WEBPACK_IMPORTED_MODULE_9__/* .YEMA_WHATSAPP */ .Y1
                            })
                        ]
                    })
                ]
            })),
            staticContent.preview && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "fixed bottom-0 flex w-full justify-between bg-brand-primary-500 px-6 py-2 font-body shadow-up",
                style: {
                    fontSize: "12px",
                    zIndex: "9999"
                },
                children: [
                    "Preview mode",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "/api/preview/end",
                        children: "Exit preview mode"
                    })
                ]
            })
        ]
    });
};
BlogLayout.defaultProps = {
    className: "page",
    staticContent: {}
};
BlogLayout.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_10__.string,
    staticContent: prop_types__WEBPACK_IMPORTED_MODULE_10__.object
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogLayout);


/***/ }),

/***/ 40325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LogosBrand_LogosBrand; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/assets/logos/LogosBrand/componentsMapping.js
/* provided dependency */ var process = __webpack_require__(34406);

var YemaIcons = {
    horizontal_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 2923).then(__webpack_require__.t.bind(__webpack_require__, 82923, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(82923)
                ];
            }
        }
    }),
    horizontal_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1166).then(__webpack_require__.t.bind(__webpack_require__, 41166, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(41166)
                ];
            }
        }
    }),
    simple_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1561).then(__webpack_require__.t.bind(__webpack_require__, 61561, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(61561)
                ];
            }
        }
    }),
    simple_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6616).then(__webpack_require__.t.bind(__webpack_require__, 66616, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(66616)
                ];
            }
        }
    }),
    mundo_y: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1424).then(__webpack_require__.t.bind(__webpack_require__, 21424, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(21424)
                ];
            }
        }
    }),
    square_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6474).then(__webpack_require__.t.bind(__webpack_require__, 56474, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(56474)
                ];
            }
        }
    }),
    square_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 8719).then(__webpack_require__.t.bind(__webpack_require__, 68719, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(68719)
                ];
            }
        }
    })
};
var T3BIcons = {
    horizontal_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6330).then(__webpack_require__.t.bind(__webpack_require__, 6330, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6330)
                ];
            }
        }
    }),
    horizontal_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6330).then(__webpack_require__.t.bind(__webpack_require__, 6330, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6330)
                ];
            }
        }
    }),
    simple_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1380).then(__webpack_require__.t.bind(__webpack_require__, 1380, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(1380)
                ];
            }
        }
    }),
    simple_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1380).then(__webpack_require__.t.bind(__webpack_require__, 1380, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(1380)
                ];
            }
        }
    }),
    mundo_y: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 6330).then(__webpack_require__.t.bind(__webpack_require__, 6330, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(6330)
                ];
            }
        }
    }),
    square_black: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1380).then(__webpack_require__.t.bind(__webpack_require__, 1380, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(1380)
                ];
            }
        }
    }),
    square_white: dynamic_default()(function() {
        return __webpack_require__.e(/* import() */ 1380).then(__webpack_require__.t.bind(__webpack_require__, 1380, 23));
    }, {
        loadableGenerated: {
            webpack: function() {
                return [
                    /*require.resolve*/(1380)
                ];
            }
        }
    })
};
var isStorefront3B = process.env.NEXT_PUBLIC_CONTEXT === "storefront_3b";
var IconsBrand = isStorefront3B ? T3BIcons : YemaIcons;

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/assets/logos/LogosBrand/LogosBrand.jsx




var LogosBrand = function(param) {
    var type = param.type, className = param.className;
    if (!type || typeof type !== "string" || type.length === 0) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var LogoBrand = IconsBrand[type] || IconsBrand.horizontal_black;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoBrand, {
        className: "max-h-16 " + className
    });
};
LogosBrand.displayName = "LogosBrand";
LogosBrand.propTypes = {
    type: prop_types.string.isRequired,
    className: prop_types.string
};
/* harmony default export */ var LogosBrand_LogosBrand = (LogosBrand);


/***/ }),

/***/ 5539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ HeaderBlog_HeaderBlog; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/assets/logos/LogosBrand/LogosBrand.jsx + 1 modules
var LogosBrand = __webpack_require__(40325);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/ArrowLeftIcon.js
var ArrowLeftIcon = __webpack_require__(49250);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/organisms/HeaderBlog/HeaderBlog.jsx






var HeaderBlog = function(param) {
    var blogUrl = param.blogUrl, storeUrl = param.storeUrl;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "sticky z-10 w-full shadow-down",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container md:py-2",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex w-full items-center justify-between p-2 lg:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                                className: "flex flex-col items-start md:items-center",
                                underline: false,
                                label: "Home",
                                href: blogUrl,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LogosBrand/* default */.Z, {
                                            type: "mundo_y",
                                            className: "my-2 inline-block w-40 lg:my-0 lg:w-48"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            className: "my-2",
                                            children: "Blog"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
                            className: "relative right-0 flex md:absolute",
                            underline: false,
                            href: storeUrl,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftIcon/* default */.Z, {
                                        className: "mr-2 h-[14px] w-[14px]"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        className: "-mt-1 md:pt-2",
                                        children: "Regresar a la tienda"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        })
    });
};
HeaderBlog.displayName = "HeaderBlog";
HeaderBlog.defaultProps = {};
HeaderBlog.propTypes = {
    blogUrl: prop_types.string.isRequired
};
/* harmony default export */ var HeaderBlog_HeaderBlog = (HeaderBlog);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/organisms/HeaderBlog/index.js



/***/ }),

/***/ 97729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(75913)


/***/ }),

/***/ 49250:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function ArrowLeftIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12.57 21a.378.378 0 01-.253-.097L3.392 12.88a1.165 1.165 0 01-.382-.804A.339.339 0 013 12c0-.02.002-.038.005-.052v-.023c.02-.312.157-.599.387-.806l8.924-8.021a.378.378 0 01.541.034c.14.162.124.41-.034.553l-8.816 7.924h16.61c.211 0 .383.175.383.391a.387.387 0 01-.383.391H4.009l8.814 7.924c.16.143.175.39.035.553a.384.384 0 01-.288.132z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(ArrowLeftIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

}]);